export const SMS_SOURCE_LABELS = {
  manual: 'Ручна відправка',
  test: 'Тест',
  registrationOtp: 'Код реєстрації',
  phoneChangeOtp: 'Зміна телефону',
  order: 'Замовлення',
  system: 'Система',
}

export const SMS_SUBMISSION_LABELS = {
  processing: 'В процесі',
  submitted: 'Прийнято',
  failed: 'Помилка',
}

export const SMS_DELIVERY_LABELS = {
  pending: 'Очікує',
  delivered: 'Доставлено',
  failed: 'Не доставлено',
  unknown: 'Невідомо',
}

export const SMS_SOURCE_OPTIONS = [
  { value: '', label: 'Усі типи повідомлень' },
  { value: 'manual', label: SMS_SOURCE_LABELS.manual },
  { value: 'test', label: SMS_SOURCE_LABELS.test },
  { value: 'registrationOtp', label: SMS_SOURCE_LABELS.registrationOtp },
  { value: 'phoneChangeOtp', label: SMS_SOURCE_LABELS.phoneChangeOtp },
  { value: 'order', label: SMS_SOURCE_LABELS.order },
  { value: 'system', label: SMS_SOURCE_LABELS.system },
]

export const SMS_SUBMISSION_OPTIONS = [
  { value: '', label: 'Усі статуси відправки' },
  { value: 'processing', label: SMS_SUBMISSION_LABELS.processing },
  { value: 'submitted', label: SMS_SUBMISSION_LABELS.submitted },
  { value: 'failed', label: SMS_SUBMISSION_LABELS.failed },
]

export const SMS_DELIVERY_OPTIONS = [
  { value: '', label: 'Усі статуси доставки' },
  { value: 'pending', label: SMS_DELIVERY_LABELS.pending },
  { value: 'delivered', label: SMS_DELIVERY_LABELS.delivered },
  { value: 'failed', label: SMS_DELIVERY_LABELS.failed },
  { value: 'unknown', label: SMS_DELIVERY_LABELS.unknown },
]

export const formatSmsTimestamp = (value) => {
  if (value == null || value === '') return '—'
  const ms = typeof value === 'number' ? value : value?.seconds ? value.seconds * 1000 : null
  if (ms == null || Number.isNaN(ms)) return '—'
  try {
    return new Date(ms).toLocaleString('uk-UA', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    })
  } catch (error) {
    return '—'
  }
}

export const formatSmsLabel = (map, value) => {
  if (value == null || value === '') return '—'
  return map[value] || value
}

export const formatTurboSmsBalance = (value) => {
  if (value == null || !Number.isFinite(Number(value))) return '—'
  return `${Number(value).toLocaleString('uk-UA', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })} грн`
}

export const MANUAL_SMS_MAX_LENGTH = 320

export const createClientRequestId = () => {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID()
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (char) => {
    const rand = (Math.random() * 16) | 0
    const value = char === 'x' ? rand : (rand & 0x3) | 0x8
    return value.toString(16)
  })
}

/** Parse UA date `dd.MM.yyyy` to ms. */
export const parseUaDateToMs = (value, { endOfDay = false } = {}) => {
  if (!value || typeof value !== 'string') return undefined
  const trimmed = value.trim()
  if (!/^\d{2}\.\d{2}\.\d{4}$/.test(trimmed)) return undefined
  const [day, month, year] = trimmed.split('.').map(Number)
  const date = endOfDay
    ? new Date(year, month - 1, day, 23, 59, 59, 999)
    : new Date(year, month - 1, day, 0, 0, 0, 0)
  const ms = date.getTime()
  return Number.isNaN(ms) ? undefined : ms
}

export const estimateSmsSegments = (text = '') => {
  const value = String(text)
  if (!value) return { length: 0, segments: 0 }
  const hasUnicode = /[^\u0000-\u007f]/.test(value)
  const perSegment = hasUnicode ? 70 : 160
  return {
    length: value.length,
    segments: Math.max(1, Math.ceil(value.length / perSegment)),
  }
}
